module.exports = __webpack_public_path__ + "img/code_116.9434365d.png";